import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { UI_LOGBOOK_DATE } from 'globalconfig/constants/static';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const ViewForm = ({ hasApiStatus, callback, history, fetchChartData, driverIdSuggestion, Styled }) => {
  const handleSubmit = (fields) => {
    const formattedFields = {
      ...fields,
      id: fields?.id?.value || '',
      startDate: fields.startDate ? moment(fields.startDate).format(UI_LOGBOOK_DATE) : '',
      endDate: fields.endDate ? moment(fields.endDate).format(UI_LOGBOOK_DATE) : '',
    };

    fetchChartData({
      apiId: 'fetchTableData',
      data: formattedFields,
      type: 'fuelEconomy',
    });
  };

  const handleCancel = () => {
    fetchChartData({
      apiId: 'fetchTableData',
      data: {
        endDate: '',
        startDate: '',
        id: '',
      },
      type: 'fuelEconomy',
    });
  };

  return (
    <Styled.Wrapper>
      <Form
        type="server"
        direction="row"
        initialValues={{
          vehicleId: '',
          endDate: '',
          startDate: '',
          id: '',
        }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        handleOnCancel={handleCancel}
        customProps={{
          history,
          callback,
          hasApiStatus,
          driverIdSuggestion,
        }}
      />
    </Styled.Wrapper>
  );
};

ViewForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default ViewForm;
